export class ProgramHomeNav {
  public static item = {
    title: 'program.tab.home',
    url: 'home',
    type: 'home',
    icon: '<img src="./assets/icons/line-icons/nav/grey/overview.svg" width="22px" height="22px">',
    testId: 'prog-nav-home',
  };
}
